import v0 from './v0';
import v1 from './v1';
import v2 from './v2';
import v3 from './v3';
import v4 from './v4';
import v5 from './v5';

/**
 * On top of the default redux-persist reconcile we add a layer of checks for the ReduxRemix project.
 * This allow us to gracefully migrate over to the new reducers, without worrying about stale localStorage state.
 * This extra layer should:
 * 1. Check for old reducer keys
 * 2. Move them to the new, respective keys
 * 3. Delete the old keys
 */
export default {
  ...v0,
  ...v1,
  ...v2,
  ...v3,
  ...v4,
  ...v5,
};
